import React, { useState } from 'react';
import StepContainer from '../../components/StepContainer';
import Button from '../../components/Button';
import { useBuildAudience } from '../../context/BuildAudienceContext';
import { UI_TEXT } from '../../config/ui-text';

interface AudienceSegmentsFocusProps {
  onNext: () => void;
  onBack: () => void;
}

const AudienceSegmentsFocus: React.FC<AudienceSegmentsFocusProps> = ({ onNext, onBack }) => {
  const { buildAudienceData, updateBuildAudienceData } = useBuildAudience();

  const [segmentationFocus, setSegmentationFocus] = useState(
    buildAudienceData.segmentationFocus || '',
  );

  const handleContinue = () => {
    // Save data and move to next step
    updateBuildAudienceData(
      {
        segmentationFocus: segmentationFocus.trim(),
      },
      2,
    );
    onNext();
  };

  const handleSegmentationFocusChange = (value: string) => {
    setSegmentationFocus(value);
    // Immediately update context to invalidate dependent data
    updateBuildAudienceData(
      {
        segmentationFocus: value.trim(),
      },
      2,
    );
  };

  return (
    <StepContainer
      title=""
      className="animate-fadeIn flex items-center justify-center min-h-[70vh]"
    >
      <div className="max-w-3xl mx-auto space-y-8 w-full">
        <div className="space-y-6">
          {/* Main Question */}
          <div className="space-y-2">
            <p className="text-sm text-gray-400 font-light mb-3">Optional</p>
            <h1 className="text-2xl font-normal text-gray-900 leading-relaxed">
              {UI_TEXT.QUESTIONNAIRE.STEP1.TITLE}
            </h1>
            <p className="text-base font-light text-gray-400 leading-relaxed">
              {UI_TEXT.QUESTIONNAIRE.STEP1.DESCRIPTION}
            </p>
          </div>

          {/* Input Field */}
          <input
            type="text"
            className={`w-full px-0 py-2 bg-transparent border-0 border-b-2 transition-all duration-200 text-2xl font-light placeholder:text-sm placeholder-gray-300 outline-none ring-0 focus:ring-0 focus:outline-none ${
              segmentationFocus ? 'border-b-primary' : 'border-b-gray-200 hover:border-b-gray-300'
            } focus:border-b-primary`}
            placeholder="Examples: Moms with infants, Gen Z and Millennials, US pet owners in urban areas, CPG and D2C brands"
            value={segmentationFocus}
            onChange={(e) => handleSegmentationFocusChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleContinue();
              }
            }}
          />
        </div>

        {/* Navigation buttons - right below the input */}
        <div className="flex items-center space-x-4">
          <Button variant="primary" onClick={handleContinue} className="font-light">
            {UI_TEXT.BUTTONS.CONTINUE}
          </Button>
          <Button
            variant="ghost"
            onClick={onBack}
            className="text-gray-400 hover:text-gray-600 font-light"
          >
            {UI_TEXT.BUTTONS.BACK}
          </Button>
        </div>
      </div>
    </StepContainer>
  );
};

export default AudienceSegmentsFocus;
